import { Pipe, PipeTransform } from '@angular/core';
import { SupplierPaymentModel } from 'src/app/models/supplier-payment.model';

@Pipe({
  name: 'filterByPaymentPages'
})
export class FilterByPaymentPagesPipe implements PipeTransform {

  transform(value: [string, SupplierPaymentModel[]][], page: number = 0, regXPage: number=2): any {
    
    return value.slice(page, page+regXPage);
  }

}
